import React from 'react'

const Disclaimer: React.FC = () => (
  <div>
    By entering your mobile number and submitting, you consent to receive text messages from Lux at the number provided. 
    Message and data rates may apply. Message frequency varies. 
    You can unsubscribe at any time by replying STOP. 
    View our <a href='/privacy'>Privacy Policy</a> and <a href='/terms'>Terms & conditions</a>.
  </div>
)

export default Disclaimer

